// extracted by mini-css-extract-plugin
export default {"ProductsContainer":"Products_ProductsContainer__NXdvo","ProductsContainer-shop":"Products_ProductsContainer-shop__x1XZF"};